import React, { useEffect, useState } from "react";
import { LinkedRecord } from "../domain/LinkedRecord";
import { LinkedRecordItem } from "./LinkedRecordItem";
import { ScrollableAreaTabFooter } from "@ofqual/portal-components/components/ScrollableAreaTabFooter";
import {
  ScrollableAreaTab,
  ScrollableAreaTabSkeleton,
} from "@ofqual/portal-components/components/ScrollableAreaTab";
import { loadingLinkedRecords } from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { linkedRecordsSelector } from "../redux/selectors";
import { AddLinkedRecordMenu } from "./AddLinkedRecordMenu";
import { List } from "@material-ui/core";

import { LinkedRecordsNullableProps } from "./LinkedRecordsProps";
import { LinkedRecordsList } from "./LinkedRecordsList";
import { useAuth } from "../hooks/useAuth";
import { UserType } from "../redux/types";

export const LinkedRecords: React.FC<LinkedRecordsNullableProps> = ({
  entityReferenceId,
  entityLinkedRecordType,
  entityTitle,
}) => {
  const dispatch = useDispatch();
  const { userType } = useAuth();
  const allowEdit = userType !== UserType.Magic;

  useEffect(() => {
    if (entityReferenceId) {
      dispatch(loadingLinkedRecords(entityReferenceId));
    }
  }, [dispatch, entityReferenceId]);

  const linkedRecordsState = useSelector(linkedRecordsSelector);
  const linkedRecords =
    entityReferenceId &&
    linkedRecordsState &&
    linkedRecordsState[entityReferenceId];

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  if (!linkedRecords) {
    return <ScrollableAreaTabSkeleton hasActions={true} />;
  }
  const knownEntityReferenceId = entityReferenceId!;

  return (
    <>
      <ScrollableAreaTab hasActions={true}>
        <LinkedRecordsList
          state={linkedRecords}
          entityId={knownEntityReferenceId}
        />
      </ScrollableAreaTab>

      {allowEdit && (
        <ScrollableAreaTabFooter
          actions={[
            {
              label: "Add Link",
              action: (el) => setAnchorEl(el),
              dataTest: "add-link-button",
            },
          ]}
        />
      )}
      {(allowEdit && anchorEl) && (
        <AddLinkedRecordMenu
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          entityReferenceId={knownEntityReferenceId}
          entityLinkedRecordType={entityLinkedRecordType}
          entityTitle={entityTitle!}
        />
      )}
    </>
  );
};
